import React from 'react';

import {
  promoCardCarouselPayloadDownloadFilename,
  serializePromoCardCarouselPayload,
  serializePromoCardCarouselPreviewPayload,
} from '~/utils/luxPlusPayloadBuilder/promoCardCarousel/buildPayload';
import { createDefaultPromoCardCarouselState } from '~/utils/luxPlusPayloadBuilder/promoCardCarousel/defaults';
import { hasPromoCardCarouselProgress } from '~/utils/luxPlusPayloadBuilder/promoCardCarousel/hasProgress';
import { parsePromoCardCarouselPayload } from '~/utils/luxPlusPayloadBuilder/promoCardCarousel/parsePayload';
import type { LuxPlusPromoCardCarouselState } from '~/utils/luxPlusPayloadBuilder/promoCardCarousel/types';
import { validatePromoCardCarouselPayload } from '~/utils/luxPlusPayloadBuilder/promoCardCarousel/validatePayload';

import PayloadBuilderJsonPreview from '../../JsonPreview';
import StandalonePayloadActions from '../../StandalonePayloadActions';
import StandalonePayloadBuilderPage from '../../StandalonePayloadBuilderPage';

import PromoCardCarouselPayloadBuilderForm from './PromoCardCarouselPayloadBuilderForm';

interface PromoCardCarouselPayloadBuilderPageProps {
  onProgressChange?: (hasProgress: boolean) => void;
}

export default function PromoCardCarouselPayloadBuilderPage({
  onProgressChange,
}: PromoCardCarouselPayloadBuilderPageProps) {
  return (
    <StandalonePayloadBuilderPage<LuxPlusPromoCardCarouselState>
      onProgressChange={onProgressChange}
      createDefaultState={createDefaultPromoCardCarouselState}
      hasProgress={hasPromoCardCarouselProgress}
      parsePayload={parsePromoCardCarouselPayload}
      validate={validatePromoCardCarouselPayload}
      renderActions={(state, isValid, fullWidth) => (
        <StandalonePayloadActions
          state={state}
          isValid={isValid}
          fullWidth={fullWidth}
          serialize={serializePromoCardCarouselPayload}
          getFilename={promoCardCarouselPayloadDownloadFilename}
          payloadName="LuxPlus+ promo cards"
        />
      )}
      renderForm={(props) => <PromoCardCarouselPayloadBuilderForm {...props} />}
      renderPreview={(state, borderSoft, maxHeight) => (
        <PayloadBuilderJsonPreview
          state={state}
          serialize={serializePromoCardCarouselPreviewPayload}
          borderSoft={borderSoft}
          maxHeight={maxHeight}
        />
      )}
    />
  );
}
